import {createContext, useContext} from 'react';
import {SnackBarContextType} from './types';

// Create Context
export const SnackBarContext = createContext<SnackBarContextType>({} as SnackBarContextType);

// Encapsulated context hook
export const useSnackBar = () => useContext(SnackBarContext);
